import en from '../lang/en'
import jp from '../lang/jp'

export default {
  'en': en,
  'jp': jp
}



// WEBPACK FOOTER //
// ./src/lang.js